import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const LabelStyle = styled.div`
  width: 100%;
  max-width: 120px;
  min-width: 105px;
  padding: 4px 8px;
  border-radius: 12px;
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 3%;

  &.with-icon {
    .icon {
      display: inline-block;
      margin-right: 8px;
      width: 16px;
      max-height: 16px;

      svg {
        width: 100%;
        height: auto;
        max-height: 100%;
      }
    }
  }

  &.default-theme {
    background-color: ${colors.grayishBlue};

    .text {
      color: ${colors.mostlyWhite};
    }

    .icon {
      svg {
        fill: ${colors.mostlyWhite};
      }
    }
  }

  &.NEW-theme {
    background-color: ${colors.softBlue};

    .text {
      color: ${colors.mostlyWhite};
    }

    .icon {
      svg {
        fill: ${colors.mostlyWhite};
      }
    }
  }

  &.APP-theme {
    background-color: ${colors.limeGreen};

    .text {
      color: ${colors.mostlyWhite};
    }

    .icon {
      svg {
        fill: ${colors.mostlyWhite};
      }
    }
  }

  &.ERR-theme {
    background-color: ${colors.softRed};

    .text {
      color: ${colors.mostlyWhite};
    }

    .icon {
      svg {
        fill: ${colors.mostlyWhite};
      }
    }
  }

  &.REV-theme {
    background-color: #fd8d6b;

    .text {
      color: ${colors.mostlyWhite};
    }

    .icon {
      svg {
        fill: ${colors.mostlyWhite};
      }
    }
  }

  &.INC-theme {
    background-color: ${colors.softYellow};

    .text {
      color: ${colors.mostlyWhite};
    }

    .icon {
      svg {
        fill: ${colors.mostlyWhite};
      }
    }
  }


  .text {
    /* display: block; */
    display: inline-block;
    ${fontFamily.sourceSansPro.bold};
    font-size: 11px;
    color: ${colors.mostlyWhite};
    line-height: 16px;
    text-align: center;
    white-space: nowrap;
  }

  .icon {
    display: none;
  }
`;
